import { DemoScript } from './demo-script.types';

/**
 * "Add a customer" — open the customers list, start a new customer, and fill the
 * whole form (clearly calling out which fields are optional). Country/currency
 * default to Türkiye/TRY on load; İl/İlçe are dependent dropdowns driven through
 * page actions. Ends by saving.
 */
export const customerScript: DemoScript = async (ctx) => {
  await ctx.goto('/dashboard?mockData=true');
  await ctx.wait(1200);

  ctx.say('Sol menüden Müşteriler sayfasına geçiyoruz');
  await ctx.click('nav-customers');
  await ctx.wait(900);

  ctx.say('Yeni bir müşteri kaydı oluşturmak için “Yeni Müşteri” butonuna tıklıyoruz');
  await ctx.click('new-customer');
  await ctx.wait(700);

  ctx.say('Müşterinin ünvanını (firma adını) yazıyoruz');
  await ctx.type('cust-name', 'name', 'Deneme Danışmanlık A.Ş.');

  ctx.say('Vergi Kimlik Numarasını (VKN) giriyoruz');
  await ctx.type('cust-taxId', 'taxId', '3216549870');

  ctx.say('Vergi dairesini giriyoruz');
  await ctx.type('cust-taxoffice', 'taxOffice', 'Kadıköy');

  ctx.say('Ülke otomatik olarak Türkiye seçilir');
  await ctx.focus('cust-country');

  ctx.say('Para birimi de otomatik olarak TRY (₺) gelir');
  await ctx.focus('cust-currency');

  ctx.say('Müşteri kodu — isteğe bağlı');
  await ctx.set('cust-code', 'customerCode', 'M-1001');

  ctx.say('e-Posta adresi — isteğe bağlı');
  await ctx.type('cust-email', 'email', 'info@deneme.com');

  ctx.say('Telefon numarası — isteğe bağlı');
  await ctx.action('cust-phone', 'fillPhone');
  await ctx.wait(400);

  ctx.say('İl seçiyoruz — isteğe bağlı');
  await ctx.action('cust-state', 'pickState');
  await ctx.wait(700);

  ctx.say('İlçe seçiyoruz — isteğe bağlı');
  await ctx.action('cust-city', 'pickCity');
  await ctx.wait(500);

  ctx.say('Fatura adresini giriyoruz');
  await ctx.type('cust-address', 'addressLine1', 'Caferağa Mah. Moda Cad. No:12, Kadıköy / İstanbul');

  ctx.say('Adres satırı 2 — isteğe bağlı');
  await ctx.set('cust-address2', 'addressLine2', 'Kat 3, Daire 12');

  ctx.say('Posta kodu — isteğe bağlı');
  await ctx.set('cust-postal', 'postalCode', '06420');

  ctx.say('Müşteriyle ilgili bir not — isteğe bağlı');
  await ctx.set('cust-notes', 'notes', 'Yıllık bakım ve destek anlaşması mevcut.');
  await ctx.wait(400);

  ctx.say('Bilgileri kontrol edip “Kaydet” diyerek müşteriyi oluşturuyoruz');
  await ctx.click('cust-save');
  await ctx.wait(1800);
};
